import { render, staticRenderFns } from "./LsAdditionalDetails.vue?vue&type=template&id=e8bd247c&scoped=true&"
import script from "./LsAdditionalDetails.vue?vue&type=script&lang=js&"
export * from "./LsAdditionalDetails.vue?vue&type=script&lang=js&"
import style0 from "./LsAdditionalDetails.vue?vue&type=style&index=0&id=e8bd247c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bd247c",
  null
  
)

export default component.exports